import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import rest from '../axios';
import './css/avaliacoes.css';

const AvaliacoesComponent = () => {
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [originalAvaliacoes, setOriginalAvaliacoes] = useState([]);
  const [providers, setProviders] = useState([]);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedAvaliacao, setSelectedAvaliacao] = useState(null);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    Promise.all([
      rest.get('/reviews'),
      rest.get('/admin/providers'),
      rest.get('/admin/users'),
    ])
      .then(([avaliacoesRes, providersRes, usersRes]) => {
        setAvaliacoes(avaliacoesRes.data?.data);
        setOriginalAvaliacoes(avaliacoesRes.data?.data);
        setProviders(providersRes.data?.data);
        setUsers(usersRes.data?.data?.users);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao carregar dados:', error);
        setLoading(false);
      });
  }, []);

  const filterTable = () => {
    let filteredAvaliacoes = originalAvaliacoes;

    if (search) {
      const filter = search.toLowerCase();
      filteredAvaliacoes = filteredAvaliacoes.filter((avaliacao) =>
        avaliacao.provider_name.toLowerCase().includes(filter) ||
        avaliacao.user_name.toLowerCase().includes(filter)
      );
    }

    if (startDate && endDate) {
      filteredAvaliacoes = filteredAvaliacoes.filter((avaliacao) => {
        const avaliacaoDate = new Date(avaliacao.created_at);
        return avaliacaoDate >= new Date(startDate) && avaliacaoDate <= new Date(endDate);
      });
    }

    setAvaliacoes(filteredAvaliacoes);
  };

  const handleAddAvaliacao = () => {
    setLoading(true);
    const newAvaliacao = {
      providerId: Number(selectedAvaliacao.provider_id),
      userId: Number(selectedAvaliacao.user_id),
      rating: Number(selectedAvaliacao.rating),
    };

    rest.post('/reviews', newAvaliacao)
      .then(() => {
        setShowAddModal(false);

        return rest.get('/reviews')
          .then((res) => {
            setAvaliacoes(res.data?.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error('Erro ao adicionar avaliação:', error);
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error('Erro ao adicionar avaliação:', error);
        setLoading(false);
      });
  };

  const handleEditAvaliacao = () => {
    if (!selectedAvaliacao) return;

    setLoading(true);
    const updatedAvaliacao = {
      providerId: Number(selectedAvaliacao.provider_id),
      userId: Number(selectedAvaliacao.user_id),
      rating: Number(selectedAvaliacao.rating),
    };

    rest.put(`/reviews/${selectedAvaliacao.id}`, updatedAvaliacao)
      .then(() => {
        setShowEditModal(false);
        setAvaliacoes((prev) =>
          prev.map((avaliacao) =>
            avaliacao.id === selectedAvaliacao.id ? { ...avaliacao, ...updatedAvaliacao } : avaliacao
          )
        );
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao editar avaliação:', error);
        setLoading(false);
      });
  };

  const handleDeleteAvaliacao = (id) => {
    setLoading(true);
    rest.delete(`/reviews/${id}`)
      .then(() => {
        setShowDeleteModal(false);
        setAvaliacoes((prev) => prev.filter((avaliacao) => avaliacao.id !== id));
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao excluir avaliação:', error);
        setLoading(false);
      });
  };

  return (
    <div className="container wrapperf">
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Pesquisar por prestador ou usuário..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              filterTable();
            }}
          />

          {/* Filtros de data */}
          <div className="d-flex mb-3">
            <Form.Control
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-2"
            />
            <Form.Control
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="me-2"
            />
            <Button variant="secondary" onClick={filterTable}>Filtrar </Button>
          </div>

          <Button variant="primary" onClick={() => setShowAddModal(true)}>
            <i className="bi bi-plus-circle me-2" />
            Adicionar Avaliação
          </Button>

          <div className="table-wrapperd">
            <table className="table mt-4">
              <thead>
                <tr>
                  <th>Prestador</th>
                  <th>Usuário</th>
                  <th>Avaliação</th>
                  <th>Data</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {avaliacoes.map((avaliacao) => (
                  <tr key={avaliacao.id}>
                    <td>{avaliacao.provider.name}</td>
                    <td>{avaliacao.user.first_name} {avaliacao.user.last_name}</td>
                    <td>{avaliacao.rating}</td>
                    <td>{new Date(avaliacao.created_at).toLocaleString()}</td>
                    <td>
                      <Button
                        variant="warning"
                        onClick={() => {
                          setSelectedAvaliacao(avaliacao);
                          setShowEditModal(true);
                        }}
                      >
                        <i className="bi bi-pencil" />
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() => {
                          setSelectedAvaliacao(avaliacao);
                          setShowDeleteModal(true);
                        }}
                      >
                        <i className="bi bi-trash" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal Adicionar Avaliação */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Avaliação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Prestador</Form.Label>
              <Form.Control
                as="select"
                name="provider_id"
                onChange={(e) =>
                  setSelectedAvaliacao({ ...selectedAvaliacao, provider_id: e.target.value })
                }
              >
                {providers.map((provider) => (
                  <option key={provider.id} value={provider.id}>
                    {provider.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Usuário</Form.Label>
              <Form.Control
                as="select"
                name="user_id"
                onChange={(e) =>
                  setSelectedAvaliacao({ ...selectedAvaliacao, user_id: e.target.value })
                }
              >
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.first_name} {user.last_name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Avaliação</Form.Label>
              <Form.Control
                type="number"
                name="rating"
                min="1"
                max="5"
                onChange={(e) =>
                  setSelectedAvaliacao({ ...selectedAvaliacao, rating: e.target.value })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleAddAvaliacao}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Editar Avaliação */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Avaliação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Prestador</Form.Label>
              <Form.Control
                as="select"
                name="provider_id"
                defaultValue={selectedAvaliacao?.provider_id}
                onChange={(e) =>
                  setSelectedAvaliacao({ ...selectedAvaliacao, provider_id: e.target.value })
                }
              >
                {providers.map((provider) => (
                  <option key={provider.id} value={provider.id}>
                    {provider.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Usuário</Form.Label>
              <Form.Control
                as="select"
                name="user_id"
                defaultValue={selectedAvaliacao?.user_id}
                onChange={(e) =>
                  setSelectedAvaliacao({ ...selectedAvaliacao, user_id: e.target.value })
                }
              >
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.first_name} {user.last_name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Avaliação</Form.Label>
              <Form.Control
                type="number"
                name="rating"
                defaultValue={selectedAvaliacao?.rating}
                min="1"
                max="5"
                onChange={(e) =>
                  setSelectedAvaliacao({ ...selectedAvaliacao, rating: e.target.value })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={() => handleEditAvaliacao(selectedAvaliacao.id)}>
            Salvar Alterações
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Excluir Avaliação */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Avaliação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Tem certeza de que deseja excluir esta avaliação?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={() => handleDeleteAvaliacao(selectedAvaliacao.id)}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default AvaliacoesComponent;
